import { createAuth0 } from '@auth0/auth0-vue'

export const auth0 = createAuth0({
  domain: 'dev-cyb4rof5mdz6h58q.us.auth0.com',
  clientId: 'xtRtUrJ1GHu5rGq6KW4tRjtRZNLqbm4D',
  authorizationParams: {
    redirect_uri: window.location.origin + '/user',
    scope: 'openid profile email',
  },
})
